/** A question's answer in its own form: options (correct one marked), blank answers, pairs, or the model answer. */
export type PreviewQuestion = {
  type: string;
  options?: string[];
  answer?: string | null;
  blanks?: string[][];
  left?: string[];
  right?: string[];
  pairs?: [number, number][];
  max_marks?: number | null;
  model_answer?: string;
  /** Paper: answered in writing and marked by the teacher, so no options. */
  graded_by_teacher?: boolean;
};

const LETTERS = ['A', 'B', 'C', 'D'];

/** Question text with [[n]] blank markers shown as blanks. */
export const withBlanks = (text: string) => text.replace(/\[\[(\d+)\]\]/g, '____');

export default function AnswerPreview({ q }: { q: PreviewQuestion }) {
  if (q.graded_by_teacher) {
    return <p className="mt-1.5 text-xs text-muted">Answered in writing on the paper; marked by the teacher.</p>;
  }
  if (q.type === 'multiple_choice') {
    return (
      <ul className="mt-1.5 grid grid-cols-1 gap-1 sm:grid-cols-2">
        {(q.options ?? []).map((o, i) => (
          <li key={i} className={`rounded-[8px] px-2 py-1 text-xs ${q.answer === LETTERS[i] ? 'bg-success-bg font-semibold text-success' : 'text-muted-2'}`}>
            {LETTERS[i]}. {o || '—'}
          </li>
        ))}
      </ul>
    );
  }
  if (q.type === 'fill_blank') {
    return <p className="mt-1.5 text-xs text-muted">Answers: {(q.blanks ?? []).map((b, i) => `${i + 1}) ${b.join(' / ') || '—'}`).join('   ')}</p>;
  }
  if (q.type === 'matching') {
    const left = q.left ?? [];
    const right = q.right ?? [];
    return (
      <ul className="mt-1.5 space-y-0.5 text-xs text-muted">
        {(q.pairs ?? []).map(([l, r]) => <li key={`${l}-${r}`}>{left[l]} → {right[r]}</li>)}
      </ul>
    );
  }
  return <p className="mt-1.5 line-clamp-2 text-xs text-muted">Model answer ({q.max_marks ?? '—'} marks): {q.model_answer || '—'}</p>;
}
